import { useEffect, useState } from 'react';
import { obterUFs } from '../../api/recursosAPI';

interface ApiStatus {
  isOnline: boolean;
}

function useApiStatus(): ApiStatus {
  const [status, setStatus] = useState<ApiStatus>({
    isOnline: true,
  });

  useEffect(() => {
    const verificarStatusApi = async () => {
      try {
        const result = await obterUFs();
        setStatus({ isOnline: !!result });
      } catch (erro) {
        setStatus({ isOnline: false });
      }
    };

    verificarStatusApi();
  }, []);

  return status;
}

export default useApiStatus;
